import { DialogCodAlternativoComponent } from "./../dialog-cod-alternativo/dialog-cod-alternativo.component";
import { CaixaModel } from "./../../../model/caixa/caixa.model";
import { TipoCaixaModel } from "./../../../model/caixa/tipocaixa.model";
import { ClienteModel } from "./../../../model/cliente/cliente.model";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { AreaService } from "./../../../service/cliente/area.service";
import { TipoCaixaService } from "./../../../service/caixa/tipo-caixa.service";
import { ClienteService } from "./../../../service/cliente/cliente.service";
import { CaixaService } from "./../../../service/caixa/caixa.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@alfresco/adf-core";
import { Component, OnInit } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-editar-caixa",
  templateUrl: "./editar-caixa.component.html",
  styleUrls: ["./editar-caixa.component.scss"],
})
export class EditarCaixaComponent implements OnInit {
  // Variáveis usadas neste component
  public cliente = {} as ClienteModel;
  public clientes: ClienteModel[];
  public tiposCaixas: TipoCaixaModel[];
  public areas: any[] = [];
  public usuario;
  public caixa = {} as CaixaModel;
  public caixaForm: FormGroup;
  public statusGuarda: "";
  public submit = false;
  public selectCliente = true;
  public disableSave = false;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public status = "EM_PROCESSO_DE_CADASTRO";
  public loading = true;
  public listaArea = false;
  animal: string;
  code: string;
  idCliente: number;
  disabledCod = true;
  caixaId;
  deData;

  adm = false;
  acervo = true;
  solicitacao = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private caixaService: CaixaService,
    private clienteService: ClienteService,
    private tipoCaixaService: TipoCaixaService,
    private areaService: AreaService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.route.params.subscribe((params) => (this.caixaId = params["id"]));
    this.deData = CryptoJS.AES.decrypt(
      decodeURIComponent(this.caixaId),
      "pcdoc"
    );
    this.caixaId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  // Chamadas feitas na inicialização do component: CaixaComponent
  ngOnInit() {
    // montando formulário da caixa
    this.caixaForm = this.fb.group({
      cliente: [null, Validators.required],
      usuarioReponsavelAbertura: ["", Validators.required],
      area: [null, Validators.required],
      tipoCaixa: [TipoCaixaModel, Validators.required],
      rgCaixa: ["", Validators.required],
      numeroCaixa: ["", Validators.required],
      codAlternativo: ["", Validators.required],
      dataInicial: ["", Validators.required],
      dataFinal: ["", Validators.required],
      dataAbertura: ["", Validators.required],
      qtdItens: [""],
      lacre1: [""],
      lacre2: [""],
      statusCaixa: [""],
      descricaoConteudoCaixa: ["", Validators.required],
      incluirConteudo: [false, Validators.required],
      statusGuarda: ["", Validators.required],
    });
    this.caixaForm.get("incluirConteudo").setValue(false);
    this.caixaForm.get("statusCaixa").setValue(this.status);
    this.caixaForm.get("area").disable();
    this.listarClientesUsuario();
    this.listarTiposDeCaixas();
    this.getUserResponsavel(sessionStorage.getItem("ACS_USERNAME"));
    if (this.caixaId !== null) {
      this.getCaixaUnica(this.caixaId);
    }
  }

  getCaixaUnica(caixaId: number) {
    this.caixaService.getCaixaUnica(caixaId).subscribe(
      (data) => {
        this.caixa = data;
        this.caixaForm.get("cliente").setValue(data.cliente);
        this.caixaForm.get("area").enable();
        this.listarAreasCliente(data.cliente.id);
        this.caixaForm.get("area").setValue(data.area);
        this.disabledCod = false;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  compararEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararClienteEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.nome === obj2.nome && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararAreaEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  openDialogCod(): void {
    const dialogRef = this.dialog.open(DialogCodAlternativoComponent, {
      width: "500px",
      data: { idCliente: this.caixaForm.get("cliente").value },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      this.code = result;
      this.caixaForm.get("codAlternativo").setValue(this.code);
      console.log(result);
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarTiposDeCaixas() {
    this.tipoCaixaService.getTipoCaixasUsuario().subscribe(
      (data) => {
        this.tiposCaixas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarAreasCliente(idCliente: number) {
    this.areaService.getAreasUsuarioCliente(idCliente).subscribe(
      (data) => {
        this.areas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getUserResponsavel(userId: string) {
    this.caixaService.getUsuarioCaixa(userId).subscribe(
      (data) => {
        this.usuario = data;
        this.caixaForm
          .get("usuarioReponsavelAbertura")
          .setValue(this.usuario.nome);
        this.loading = false;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getClienteById(idCliente: number) {
    this.clienteService.getClienteUnico(idCliente).subscribe(
      (data) => {
        this.cliente = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  onChange(event) {
    const idCliente = this.caixaForm.get("cliente").value.id;
    this.idCliente = idCliente;
    this.selectCliente = false;
    this.disabledCod = false;
    this.caixaForm.get("area").enable();
    this.listarAreasCliente(idCliente);
    this.listaArea = true;
  }

  onSubmit(conteudo) {
    this.submit = true;
    if (this.caixaId !== null) {
      this.editCaixa(conteudo);
    } else {
      this.saveCaixa();
    }
  }

  saveCaixa() {
    if (this.isFormInvalid) {
      this.loading = true;
      this.caixaService.saveCaixa(this.caixaForm.value).subscribe(
        (data) => {
          this.loading = false;
          this.openSnackBarSuccess(
            `Caixa com o RG: ${data.rgCaixa} salva com sucesso !`
          );
          if (data.incluirConteudo === true) {
            const idCrypt = encodeURIComponent(
              CryptoJS.AES.encrypt(JSON.stringify(data.id), "pcdoc").toString()
            );
            setTimeout(() => {
              setTimeout(() => {
                this.router.navigate(["/incluir-conteudo", idCrypt]);
              }, 1000);
              this.openSnackBarSuccess(
                "Redirecionando para página da caixa criada !"
              );
            }, 3000);
          } else {
            setTimeout(() => {
              setTimeout(() => {
                this.router.navigate(["/listar-caixas"]);
              }, 1000);
              this.openSnackBarSuccess(
                "Redirecionando para página de caixas !"
              );
            }, 3000);
          }
        },
        (err) => {
          console.error(err);
          this.loading = false;
          this.openSnackBarError(err.error.errors[0].defaultMessage);
        }
      );
    } else {
      this.openSnackBarError("Preencha todos os campos obrigatórios !");
    }
  }

  editCaixa(caixa: CaixaModel) {
    this.loading = true;
    this.caixaService.editarCaixa(caixa).subscribe(
      (data) => {
        this.loading = false;
        this.openSnackBarSuccess(
          `Caixa com o RG: ${data.rgCaixa} editada com sucesso !`
        );
        if (data.incluirConteudo === true) {
          const idCrypt = encodeURIComponent(
            CryptoJS.AES.encrypt(JSON.stringify(data.id), "pcdoc").toString()
          );
          setTimeout(() => {
            setTimeout(() => {
              this.router.navigate(["/incluir-conteudo", idCrypt]);
            }, 1000);
            this.openSnackBarSuccess("Redirecionando para página da caixa !");
          }, 3000);
        } else {
          setTimeout(() => {
            setTimeout(() => {
              this.router.navigate(["/listar-caixas"]);
            }, 1000);
            this.openSnackBarSuccess("Redirecionando para página de caixas !");
          }, 3000);
        }
        console.log(data);
      },
      (err) => {
        this.loading = false;
        this.openSnackBarError("Preencha todos os campos obrigatórios !");
        console.error(err);
      }
    );
  }

  reset() {
    this.submit = false;
    this.listaArea = false;
    this.disabledCod = true;
    this.caixaForm.get("cliente").reset();
    this.caixaForm.get("area").reset();
    this.caixaForm.get("tipoCaixa").reset();
    this.caixaForm.get("statusGuarda").reset();
    this.caixaForm.get("rgCaixa").reset();
    this.caixaForm.get("numeroCaixa").reset();
    this.caixaForm.get("codAlternativo").reset();
    this.caixaForm.get("dataInicial").reset();
    this.caixaForm.get("dataFinal").reset();
    this.caixaForm.get("dataAbertura").reset();
    this.caixaForm.get("qtdItens").reset();
    this.caixaForm.get("lacre1").reset();
    this.caixaForm.get("lacre2").reset();
    this.caixaForm.get("descricaoConteudoCaixa").reset();
    this.caixaForm.get("incluirConteudo").setValue(false);
  }

  isFormInvalid(): boolean {
    return (
      this.caixaForm.get("cliente").value.email === null ||
      this.caixaForm.get("usuarioReponsavelAbertura").value === null ||
      this.caixaForm.get("area").value.descricao === null ||
      this.caixaForm.get("tipoCaixa").value.descricao === null ||
      this.caixaForm.get("statusGuarda").value === null ||
      this.caixaForm.get("rgCaixa").value === null ||
      this.caixaForm.get("numeroCaixa").value === null ||
      this.caixaForm.get("codAlternativo").value === null ||
      this.caixaForm.get("dataInicial").value === null ||
      this.caixaForm.get("dataFinal").value === null ||
      this.caixaForm.get("dataAbertura").value === null
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/editar-caixa/editar-caixa.component.ts